import type { LOCALE_MAPPING } from "./locale-mappings";

function getValueFromMapping(mapping: LOCALE_MAPPING) {
	const firstKey = Object.keys(mapping)[0];
	return mapping[firstKey];
}

export function lookupLocale(locale: string, availableLocales: LOCALE_MAPPING[]): string {
	if (!availableLocales || availableLocales.length === 0) {
		return "de";
	}

	const defaultLocale = availableLocales[0]["de"];

	if (!locale) {
		return defaultLocale;
	}

	locale = locale.toLowerCase();

	let localeMatch = availableLocales.find((al) =>
		Object.keys(al).find((k) => k.toLowerCase() === locale),
	);
	if (localeMatch) {
		return getValueFromMapping(localeMatch);
	}

	if (locale.indexOf("-") === -1) {
		return defaultLocale;
	}

	while (locale.lastIndexOf("-") > -1) {
		locale = locale.substring(0, locale.lastIndexOf("-"));
		localeMatch = availableLocales.find((al) =>
			Object.keys(al).find((k) => k.toLowerCase() === locale),
		);
		if (localeMatch) {
			return getValueFromMapping(localeMatch);
		}
	}

	return defaultLocale;
}
